import styled from 'styled-components';
import List from '@material-ui/core/List';

export default styled(List)`
  && {
  }
`;
